<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    getUrlParms(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    goConcern() {
      let that = this;
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          wx.miniProgram.reLaunch({
            url: `/pages/home/concern?code=` + that.getUrlParms("code"),
          });
        } else {
          console.log("微信中打开");
        }
      });
    },
  },
  created() {
    window.document.title = " ";
    if (this.getUrlParms("code")) {
      this.goConcern();
    } else {
        var appId = "wx517b799350afbe6c",
          redirectUri = encodeURIComponent(
            `https://xrk.paiaipao.cn/#/mini-concern`
          );
        if (!location.hostname.includes("dev")) {
          redirectUri = encodeURIComponent(
            `https://xrk.paiaipao.cn/#/mini-concern`
          );
        }
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
    }
  },
};
</script>